import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

// Connects to data-controller="leave-confirmation"
export default class extends Controller {
  static targets = ["modal"];

  declare modalTarget: HTMLElement;
  declare destinationUrl: string | null;
  declare modal: Modal;
  declare boundLinkClickHandler: (event: Event) => void;

  // MEMO: jsでモーダルの表示・非表示を制御します
  connect() {
    this.modal = new Modal(this.modalTarget);
    // リンクのクリックを検知
    this.boundLinkClickHandler = this.handleLinkClick.bind(this);
    document.addEventListener("click", this.boundLinkClickHandler);
  }

  disconnect() {
    document.removeEventListener("click", this.boundLinkClickHandler);
  }

  handleLinkClick(event: Event) {
    // aタグがクリックされた場合
    const clickedLink = (event.target as Element).closest("a");

    // 別タブで開くリンク（target="_blank"）またはdata-bypass-confirmationがある場合はスキップ
    if (
      clickedLink &&
      !clickedLink.hasAttribute("data-bypass-confirmation") &&
      clickedLink.getAttribute("target") !== "_blank" &&
      this.hasUnsavedChanges()
    ) {
      event.preventDefault();
      this.destinationUrl = clickedLink.getAttribute("href");
      this.modal.show();
    }
  }

  hasUnsavedChanges(): boolean {
    // MEMO: ロジック複雑になるのでフォームの変更は検知しない
    return true;
  }

  continueWithoutSaving() {
    // 保存せずに移動する場合
    this.modal.hide();
    if (this.destinationUrl) {
      window.location.href = this.destinationUrl;
    }
  }

  cancel() {
    // モーダルでキャンセルした場合
    this.modal.hide();
    this.destinationUrl = null;
  }
}
